import { render, staticRenderFns } from "./simpleselect.vue?vue&type=template&id=6fd9d317&"
import script from "./simpleselect.vue?vue&type=script&lang=js&"
export * from "./simpleselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports